import { render, staticRenderFns } from "./MapaServicio.vue?vue&type=template&id=3fc7b0e5&scoped=true&"
import script from "./MapaServicio.vue?vue&type=script&lang=js&"
export * from "./MapaServicio.vue?vue&type=script&lang=js&"
import style0 from "./MapaServicio.vue?vue&type=style&index=0&id=3fc7b0e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7b0e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
